
import { useEffect } from "react";

const useRestrictCopyPaste = ({onAction,targetRef }) => {
  useEffect(() => {
    if (!targetRef?.current) return
    const preventAction = (e) => {
      e.preventDefault();
      if (onAction) {
        onAction(e.type); // Pass the event type: "copy", "paste", or "cut"
      }
    };

  const handleKeyDown = (e) => {
    if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'c') {
      e.preventDefault();
      if (onAction) {
        onAction(e.type); // Pass the event type: keydown
      }
    }
  };
  const element = targetRef.current;

  const handleMouseUp = (e) => {
    const selection = window.getSelection();
    const selectedText = selection?.toString();
    const length = selectedText?.length;
  
    if (length > 0 && element && selection?.rangeCount > 0) {
      const range = selection?.getRangeAt(0);
      const intersectsProtected = range?.intersectsNode(element);
      if (intersectsProtected && typeof onAction === "function") {
        e.preventDefault();
        onAction("textSelected");
      }
    }
  };

    ["copy", "cut", "contextmenu"].forEach((event) =>   // add contextmenu to handle right click , "selectstart" is removed from array because on mouse left click popup was getting true 
        element.addEventListener(event, preventAction) 
    );
    element.addEventListener('keydown', handleKeyDown);
    document.addEventListener("mouseup", handleMouseUp);

    return () => {
      ["copy", "cut", "contextmenu"].forEach((event) =>  // add contextmenu to handle right click 
        element.removeEventListener(event, preventAction)
      );
      element.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, [onAction,targetRef]);
};

export default useRestrictCopyPaste
